import { validateAirlineByCode } from "@/api/airlinesApi";
import { transportMapper } from "@/services/TransportMapper/TransportMapper";
import { ManualTransport, SelectedTransport } from "../types/types";
import { determineAirlineCode } from "./determineAirlineCode";

export const processManualTransport = async (
  manualTransport: ManualTransport
): Promise<SelectedTransport> => {
  const airlineCode: string | undefined = determineAirlineCode(
    manualTransport.flightNumber
  );
  const needsAirlineValidation: boolean =
    (airlineCode && airlineCode.length === 3) || false;
  const { isValid: isICAO } = await validateAirlineByCode(
    airlineCode,
    needsAirlineValidation
  );

  const updatedManualTransport: ManualTransport = {
    ...manualTransport,
    airlineIata: isICAO ? airlineCode : airlineCode?.slice(0, 2),
  };

  return transportMapper.fromManualTransport(updatedManualTransport);
};
